module.exports = "/virtual-football-league/img/amblems/right/France/Fake_Lyon.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/France/Fake_Lyon.png
// module id = 2135
// module chunks = 4